export default function headerScrollAnimation (){

	const header = document.querySelector('header');
	const headerWrapper = header.querySelector('header .header-wrapper');
	const headerMobile = header.querySelector('.header-mobile');
	const logoImage = headerWrapper.querySelector('.header-bottom .logo img');

	const subNavigationWrapper = document.querySelector('header .sub-navigation-wrapper');

	import(/* webpackChunkName: "gsap" */'gsap').then(({default: gsap}) => {
		import(/* webpackChunkName: "gsap-scrolltrigger" */'gsap/ScrollTrigger').then(({ScrollTrigger}) => {
			gsap.registerPlugin(ScrollTrigger);

			// Function to check if the viewport is in mobile view
			function isMobileView() {
				return window.innerWidth <= 1200; // Adjust the width as per your mobile breakpoint
			}


			function initAnimation() {

				if (header && headerWrapper && headerWrapper.classList.contains('is-transparent')) {
					gsap.to('header', {
						scrollTrigger: {
							trigger: 'header',
							start: 'top top',
							scrub: 1,
							onLeave: (self) => {
								if (!headerWrapper.classList.contains('is-scrolling')) {
									headerWrapper.classList.add('is-scrolling');
								}

							},
							onLeaveBack: (self) => {
								if (headerWrapper.classList.contains('is-scrolling')) {
									headerWrapper.classList.remove('is-scrolling');
								}

							}
						}, // start the animation when ".box" enters the viewport (once)
						background: '#fff',
					});
				}

				if (subNavigationWrapper && !isMobileView()) {
					gsap.to('.sub-navigation-wrapper > .sub-navigation', {
						scrollTrigger: {
							trigger: '.sub-navigation-wrapper',
							start: 'top top',
							endTrigger: 'footer', // The element that will end the pinning
							end: '+=50000', // End when the top of the footer reaches the bottom of the viewport
							pin: true, // Pin the element
							pinSpacing: false, // Remove extra space added by pinning
							// markers: true,
							// scrub: 1,
							onLeaveBack: () => {
								// Reset margin when leaving pinned state
								gsap.to('.sub-navigation-wrapper > .sub-navigation', {
									position: 'relative',
									top: '',
									left: '',
									right: '',
									zIndex: '',
									marginLeft: '48px',
									marginRight: '48px',
									duration: 0.1, // Adjust the duration as needed
									ease: 'power1.inOut' // Use an easing function for smooth transition
								});
							},
							onEnter: () => {
								// Set margin to 0 when re-entering pinned state
								gsap.to('.sub-navigation-wrapper > .sub-navigation', {
									position: 'fixed',
									top: 0,
									left: 0,
									right: 0,
									zIndex: 1000,
									marginLeft: 0,
									marginRight: 0,
									duration: 0.1, // Adjust the duration as needed
									ease: 'power1.inOut' // Use an easing function for smooth transition
								});
							}
						},
						marginLeft: 0,
						marginRight: 0,
						duration: 0.1, // Adjust the duration as needed
						ease: 'power1.inOut' // Use an easing function for smooth transition
					});
				}


				if (headerMobile) {
					gsap.to('.header-mobile', {
						scrollTrigger: {
							trigger: '.header-mobile',
							start: 'top top',
							scrub: 1,
							onLeave: (self) => {
								if (!headerMobile.classList.contains('is-scrolling')) {
									headerMobile.classList.add('is-scrolling');
								}

							},
							onLeaveBack: (self) => {
								if (headerMobile.classList.contains('is-scrolling')) {
									headerMobile.classList.remove('is-scrolling');
								}

							}
						}, // start the animation when ".box" enters the viewport (once)
						background: '#fff',
					});
				}

			}

			// Initialize the animation
			initAnimation();

		})
	});
}

